import { HttpHeaders } from "@angular/common/http";

/** Nombre de header para `NO CACHEAR RESPUESTA OK` */
export const HEADER_NAME_DONT_SAVE_REQ = 'dsrq';
/** Nombre de header para `RESETEAR` una respuesta OK cacheada */
export const HEADER_NAME_RESET_REQ = 'rst';

/** Header de angular para `NO` salvar respuesta OK */
export const HEADER_DONT_SAVE_REQ = new HttpHeaders().set(HEADER_NAME_DONT_SAVE_REQ, '1');
/** Header de angular para `RESETEAR` respuesta OK cacheada */
export const HEADER_RESET_REQ = new HttpHeaders().set(HEADER_NAME_RESET_REQ, '1');

export const HEADER_DONT_SAVE = { headers: HEADER_DONT_SAVE_REQ };
export const HEADER_RESET = { headers: HEADER_RESET_REQ };
